(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mmx-home-crucifix"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (root._mmxCrucifixSwiper || !window.Swiper) return;

      const swiperEl = root.querySelector('[data-mmx-crucifix-swiper]');
      const paginationEl = root.querySelector('[data-mmx-crucifix-pagination]');
      if (!swiperEl || !paginationEl) return;

      root._mmxCrucifixSwiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 35,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });
    }

    function bootWhenReady() {
      if (!window.Swiper) {
        window.requestAnimationFrame(bootWhenReady);
        return;
      }
      document.querySelectorAll('[data-mmx-home-crucifix]').forEach(initSection);
    }

    bootWhenReady();

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-mmx-home-crucifix]');
      if (root) initSection(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-home-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setActiveBullet(root, index) {
      root.querySelectorAll('[data-mmx-testimonials-bullet]').forEach((bullet) => {
        const bulletIndex = parseInt(bullet.dataset.index || '0', 10);
        const isActive = bulletIndex === index;
        bullet.classList.toggle('is-active', isActive);
        bullet.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function initSection(root) {
      if (root._mmxSwiper || !window.Swiper) return;

      const swiperEl = root.querySelector('[data-mmx-testimonials-swiper]');
      if (!swiperEl) return;

      const swiper = new Swiper(swiperEl, {
        initialSlide: 1,
        slidesPerView: 'auto',
        spaceBetween: 0,
        speed: 500,
        slideToClickedSlide: true,
        centeredSlides: true,
        breakpoints: {
          1024: {
            slidesPerView: 3
          },
        },
        on: {
          init(instance) {
            setActiveBullet(root, instance.activeIndex);
          },
          slideChange(instance) {
            setActiveBullet(root, instance.activeIndex);
          },
        },
      });

      root._mmxSwiper = swiper;

      const nextBtn = root.querySelector('[data-mmx-testimonials-next]');
      if (nextBtn) {
        nextBtn.addEventListener('click', () => swiper.slideNext());
      }

      root.querySelectorAll('[data-mmx-testimonials-bullet]').forEach((bullet) => {
        bullet.addEventListener('click', () => {
          const index = parseInt(bullet.dataset.index || '0', 10);
          swiper.slideTo(index);
        });
      });
    }

    function boot() {
      document.querySelectorAll('[data-mmx-home-testimonials]').forEach(initSection);
    }

    function bootWhenReady() {
      if (!window.Swiper) {
        window.requestAnimationFrame(bootWhenReady);
        return;
      }
      boot();
    }

    bootWhenReady();

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-mmx-home-testimonials]');
      if (root) initSection(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-crucifix-campaign"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-campaign-config]').textContent);
    const forms = [...root.querySelectorAll('.nfc-product-form')];
    const currentVariant = form => form.querySelector('select[name="id"]')?.selectedOptions[0] || form.querySelector('[name="id"]:checked');
    let cartBusy = false;
    const updateButtons = () => forms.forEach(form => {
      const current = currentVariant(form);
      const button = form.querySelector('[type="submit"], [data-cart-submit]');
      button.disabled = cartBusy || !current || current.dataset.available !== 'true';
      button.querySelector('[data-add-label]').textContent = cartBusy ? config.adding : button.disabled ? config.soldOut : form.classList.contains('nfc-quick-form') ? config.shortAdd : config.add;
    });
    const syncVariant = source => {
      const current = currentVariant(source);
      if (!current) return;
      forms.forEach(form => {
        const select = form.querySelector('select[name="id"]');
        if (select) select.value = current.value;
        else form.querySelectorAll('[name="id"]').forEach(input => { input.checked = input.value === current.value; });
        form.querySelector('[data-price]').textContent = current.dataset.price;
        form.querySelector('.nfc-form-status').textContent = '';
        form.querySelector('.nfc-cart-next').hidden = true;
      });
      root.querySelector('[data-sticky-price]').textContent = current.dataset.price;
      root.querySelectorAll('[data-variant-scene]').forEach(scene => { scene.hidden = scene.dataset.variantScene !== current.value; });
      root.querySelector('[data-hero-price]').textContent = current.dataset.price;
      const mediaChoice = root.querySelector('.nfc-quick-form [name="id"]:checked');
      if (mediaChoice) root.dispatchEvent(new CustomEvent('nfc:variant-change', { detail: { id:mediaChoice.value, ...mediaChoice.dataset } }));
      updateButtons();
    };
    forms.forEach(form => {
      const button = form.querySelector('[type="submit"]');
      const status = form.querySelector('.nfc-form-status');
      form.addEventListener('change', () => syncVariant(form));
      const addToCart = async event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        const selected = currentVariant(form);
        if (cartBusy || !selected || selected.dataset.available !== 'true') return;
        cartBusy = true;
        updateButtons();
        status.textContent = '';
        form.querySelector('.nfc-cart-next').hidden = true;
        try {
          if (window.NFB) { await window.NFB.add([{id:Number(selected.value),quantity:1}]); return; }
          const response = await fetch(config.cartAdd, { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:Number(selected.value),quantity:1}]}) });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || config.error);
          status.textContent = config.added;
          form.querySelector('.nfc-cart-next').hidden = false;
          fetch(config.cart).then(r=>r.json()).then(cart=>{root.querySelector('[data-cart-count]').textContent=cart.item_count;}).catch(()=>{});
        } catch(error) { status.textContent = error.message || config.error; }
        finally { cartBusy = false; updateButtons(); }
      };
      button.dataset.cartSubmit = '';
      button.type = 'button';
      button.addEventListener('click', addToCart, true);
      form.addEventListener('submit', addToCart, true);
    });
    root.querySelectorAll('[data-film]').forEach(film => {
      const trigger = film.querySelector('[data-play]');
      const player = film.querySelector('.nfc-film-player');
      const video = film.querySelector('video');
      if (!trigger || !video) return;
      trigger.addEventListener('click', () => {
        root.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();});
        if (!video.getAttribute('src') && video.dataset.desktop) {
          const connection = navigator.connection;
          const light = matchMedia('(max-width: 760px)').matches || connection?.saveData || /(^|-)2g|3g/.test(connection?.effectiveType || '');
          video.src = (light && video.dataset.mobile) || video.dataset.desktop;
          video.load();
        }
        player.hidden = false;
        trigger.hidden = true;
        video.focus();
        video.play().catch(()=>{});
      });
      video.addEventListener('error',()=>{player.hidden=true;trigger.hidden=false;});
    });
    const sticky = root.querySelector('.nfc-sticky');
    const hero = root.querySelector('.nfc-hero');
    const buy = root.querySelector('.nfc-buy');
    let heroVisible = true, buyVisible = false;
    const observer = new IntersectionObserver(entries=>{
      for(const entry of entries){if(entry.target===hero)heroVisible=entry.isIntersecting;if(entry.target===buy)buyVisible=entry.isIntersecting;}
      const visible = !heroVisible && !buyVisible;
      sticky.classList.toggle('is-visible', visible);
      sticky.inert = !visible;
    },{threshold:0});
    observer.observe(hero);observer.observe(buy);
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))observer.disconnect();},{once:true});
  };
  document.querySelectorAll('[data-campaign]').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-campaign]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-slideshow-v-2-0"] && !Shopify.designMode) return;
  try {
    
  // Slideshow component
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.ss-slideshow__slide');
      if (this.slides.length <= 1) return;

      this.currentSlideIndicator = this.querySelector('.ss-current-slide-indicator');
      this.currentSlideIndex = this.dataset.activeSlide;
      this.counterControls = this.querySelectorAll('.ss-slideshow-controls__link');

      this.nextControl = this.querySelector('.ss-slideshow-control--next');
      this.previousControl = this.querySelector('.ss-slideshow-control--previous');

      if (this.getAttribute('data-autoplay') === 'true') {
        this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) * 1000;
        this.isAutoplayButtonSetToPlay = true;
        this.setAutoPlay();
      }

      this.initButtons();
    }

    initButtons() {
      this.nextControl.addEventListener('click', () => {
        this.updateSlideshow('next');
        this.resetAutoPlay();
      });

      this.previousControl.addEventListener('click', () => {
        this.updateSlideshow('previous');
        this.resetAutoPlay();
      });

      this.counterControls.forEach((control) => {
        control.addEventListener('click', () => {
          if (this.currentSlideIndex == control.dataset.slideNumber) return;
          this.updateSlideshow(control.dataset.slideNumber);
          this.resetAutoPlay();
        });
      });
    }

    updateSlideshow(target = 'next') {
      let nextSlideIndex = 0;
      let transitionDirection = target;

      switch (target) {
        case 'next':
          nextSlideIndex = parseInt(this.dataset.activeSlide) + 1;
          break;
        case 'previous':
          nextSlideIndex = parseInt(this.dataset.activeSlide) - 1;
          break;
        default:
          nextSlideIndex = target;
          transitionDirection = nextSlideIndex > this.dataset.activeSlide ? 'next' : 'previous';
          break;
      }

      if (nextSlideIndex < 0) {
        nextSlideIndex = this.slides.length - 1;
      } else if (nextSlideIndex >= this.slides.length) {
        nextSlideIndex = 0;
      }

      this.slideTransition(this.slides[this.dataset.activeSlide], this.slides[nextSlideIndex], transitionDirection);
      this.updateControls(nextSlideIndex);
      this.dataset.activeSlide = nextSlideIndex;
      this.currentSlideIndex = nextSlideIndex;
    }

    slideTransition(currentSlide, nextSlide, transitionDirection) {
      const slideshowControls = this.querySelectorAll('.ss-slideshow-control');
      slideshowControls.forEach((control) => {
        control.setAttribute('disabled', 'true');
      });

      currentSlide.addEventListener('animationend', (event) => {
        if (event.animationName.includes('ssSlideIn')) return;

        // Hide slides & reset transitions
        this.slides.forEach((slide) => {
          slide.setAttribute('aria-hidden', 'true');
          slide.classList.remove(`ss-slide--transition-out-${transitionDirection}`);
        });

        // Set new slide to active
        nextSlide.setAttribute('aria-hidden', 'false');
        nextSlide.classList.remove(`ss-slide--${transitionDirection}`);
        slideshowControls.forEach((control) => {
          control.removeAttribute('disabled');
        });
      });

      // Start slide transition
      currentSlide.classList.add(`ss-slide--transition-out-${transitionDirection}`);
      nextSlide.classList.add(`ss-slide--${transitionDirection}`);
    }

    updateControls(newSlideIndex) {
      // If we have a current slide indicator (i.e. 2/3), update it
      if (this.currentSlideIndicator) {
        this.currentSlideIndicator.innerText = `${newSlideIndex + 1}/${this.slides.length}`;
        return;
      }

      this.counterControls.forEach((control) => {
        control.classList.remove('ss-slideshow-controls__link--active');
      });
      this.counterControls[newSlideIndex].classList.add('ss-slideshow-controls__link--active');
    }

    resetAutoPlay() {
      if (this.isAutoplayButtonSetToPlay) {
        this.play();
      }
    }

    /* Handle autoplay */
    setAutoPlay() {
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));

      this.sliderAutoplayButton = this.querySelector('.ss-slideshow-control--autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.isAutoplayButtonSetToPlay = true;
      this.play();
    }

    autoPlayToggle() {
      this.togglePlayButtonState(this.isAutoplayButtonSetToPlay);
      this.isAutoplayButtonSetToPlay ? this.pause() : this.play();
      this.isAutoplayButtonSetToPlay = !this.isAutoplayButtonSetToPlay;
    }

    togglePlayButtonState(pauseAutoplay) {
      this.sliderAutoplayButton.classList.toggle('ss-slideshow-control--autoplay--paused', pauseAutoplay);
      pauseAutoplay
        ? this.sliderAutoplayButton.setAttribute('aria-label', 'Play slideshow')
        : this.sliderAutoplayButton.setAttribute('aria-label', 'Pause slideshow');
    }

    play() {
      this.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
      this.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }

    autoRotateSlides() {
      this.updateSlideshow('next');
    }

    focusOutHandling(event) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);

      if (this.isAutoplayButtonSetToPlay && !focusedOnAutoplayButton) this.play();
    }

    focusInHandling(event) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);

      if (this.isAutoplayButtonSetToPlay) {
        focusedOnAutoplayButton ? this.play() : this.pause();
      }
    }
  }

  if (!customElements.get('ss-slideshow-component')) {
    customElements.define('ss-slideshow-component', SlideshowComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
